<div class="tab-content" id="tabComponentsContent">
  <div
    class="tab-pane fade show active"
    id="labels"
    role="tabpanel"
    aria-labelledby="labels-tab"
  >
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form [formGroup]="formGroup">
              <div class="row">
                <div class="col-xs-12 col-md-9 input-trend-search">
                  <input
                    type="search"
                    #searchBox
                    class="form-control"
                    [placeholder]="'tabulation.list.searchPlaceholder' | translate"
                    formControlName="search"
                    (keyup)="search(searchBox.value)"
                  />
                  <span class="mdi mdi-magnify search-icon ml-2"></span>
                </div>

                <div class="col-xs-12 col-lg-3 btn-group trend-button">
                  <button class="btn btn-info fw-bold" (click)="add()">
                    {{ 'tabulation.list.addButton' | translate }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    @if (loadingContent) {
      <content-loading-list />
    }

    @if (pager.total == 0) {
      <empty-records-component
        [message]="'tabulation.list.emptyMessage' | translate"
        [subMessage]="'tabulation.list.emptySubMessage' | translate"
        [labelButton]="'tabulation.list.addButton' | translate"
        [icon]="'mdi mdi-alert-circle-outline'"
        (emitEvent)="add()"
      />
    }

    @if (!loadingContent && pager.total > 0) {
      <div class="card">
        <div class="card-body table-responsive">
          <table class="table table-hover table-centered mb-0">
            <thead>
              <tr>
                <th class="text-primary-emphasis">{{ 'tabulation.list.columnName' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'tabulation.list.columnChannel' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'tabulation.list.columnCreatedAt' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'tabulation.list.columnDescription' | translate }}</th>
                <th><span class="sr-only"></span></th>
              </tr>
            </thead>
            <tbody>
              @for (item of pager.list; track $index) {
                <tr>
                  <td>{{ item.name }}</td>
                  <td>{{ item.channel?.name ?? "-" }}</td>
                  <td>
                    <span>{{
                      item.createdAt
                        | timezoneDate
                          : "DD/MM/YYYY"
                          : getTimezoneCompanyCurrentUser()
                    }}</span>
                  </td>
                  <td>{{ item.description ?? "-" }}</td>
                  <td>
                    <div class="d-flex justify-content-end">
                      <button
                        type="button"
                        class="btn btn-dropdown-list"
                        [matMenuTriggerFor]="menu"
                      >
                        <i
                          class="mdi mdi-dots-vertical text-primary-emphasis"
                        ></i>
                      </button>

                      <mat-menu #menu="matMenu">
                        <button mat-menu-item tabindex="0" (click)="edit(item)">
                          {{ 'tabulation.list.editAction' | translate }}
                        </button>
                        @if (isAdmin()) {
                          <button
                            mat-menu-item
                            tabindex="0"
                            (click)="delete(item)"
                          >
                            {{ 'tabulation.list.deleteAction' | translate }}
                          </button>
                        }
                      </mat-menu>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
          @if (pager.total > pager.perPage) {
            <paginator [pager]="pager" (onPager)="loadPage($event)" />
          }
        </div>
      </div>
    }
  </div>
</div>
